/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactDraft
 */
export interface ContactDraft {
    /**
     * 
     * @type {string}
     * @memberof ContactDraft
     */
    emailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDraft
     */
    contactName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDraft
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDraft
     */
    phoneNumberExtension?: string;
}

/**
 * Check if a given object implements the ContactDraft interface.
 */
export function instanceOfContactDraft(value: object): value is ContactDraft {
    return true;
}

export function ContactDraftFromJSON(json: any): ContactDraft {
    return ContactDraftFromJSONTyped(json, false);
}

export function ContactDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'emailAddress': json['emailAddress'] == null ? undefined : json['emailAddress'],
        'contactName': json['contactName'] == null ? undefined : json['contactName'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'phoneNumberExtension': json['phoneNumberExtension'] == null ? undefined : json['phoneNumberExtension'],
    };
}

  export function ContactDraftToJSON(json: any): ContactDraft {
      return ContactDraftToJSONTyped(json, false);
  }

  export function ContactDraftToJSONTyped(value?: ContactDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emailAddress': value['emailAddress'],
        'contactName': value['contactName'],
        'phoneNumber': value['phoneNumber'],
        'phoneNumberExtension': value['phoneNumberExtension'],
    };
}

